import {viewDD} from '../actions/Project'

export default function handleDD(id) {
    viewDD(id)
    window.open('https://rocketdao.io/DueD/Multy.pdf')
}
